/**
 * phase2TaskColumns.ts
 * FEAT-2026-0007 Phase 6C.1 — Column configuration for the Phase-2 scenario task table.
 *
 * Per CODING-STANDARDS.md: column configs are data objects, not inline JSX.
 *
 * Phase-2 shows the SAME tasks as Phase-1 but machine columns are read-only.
 * An "Assigned Employees" column is appended.
 *
 * Columns:
 *   # · Task Name · Test Qty · Machine Qty (read-only) · Assigned Machine(s) (read-only) ·
 *   Start Date · End Date · Duration (Days) · Assigned Employees (Skill Level)
 */

export interface Phase2TaskColumn {
  id: string;
  label: string;
  width: string | number;
  align?: 'left' | 'center' | 'right';
  tooltip?: string;
}

export const PHASE2_TASK_COLUMNS: Phase2TaskColumn[] = [
  {
    id: 'rowNumber',
    label: '#',
    width: '3%',
    align: 'center',
  },
  {
    id: 'Name',
    label: 'Task Name',
    width: '15%',
    align: 'left',
  },
  {
    id: 'TestQty',
    label: 'Test Qty',
    width: '6%',
    align: 'center',
    tooltip: 'Number of tests requested in the source quote or work order line item.',
  },
  {
    id: 'MachineCount',
    label: 'Machine Qty',
    width: '7%',
    align: 'center',
    tooltip: 'Number of machines assigned (set in Phase 1 — read-only here).',
  },
  {
    id: 'Machines',
    label: 'Assigned Machine(s)',
    width: '15%',
    align: 'left',
    tooltip: 'Machines locked in Phase 1 — read-only in this phase.',
  },
  {
    id: 'StartDate',
    label: 'Start Date',
    width: '9%',
    align: 'center',
  },
  {
    id: 'EndDate',
    label: 'End Date',
    width: '9%',
    align: 'center',
  },
  {
    id: 'Duration',
    label: 'Duration (Days)',
    width: '9%',
    align: 'center',
    tooltip: 'Computed from Start and End dates (inclusive).',
  },
  {
    id: 'Assignees',
    label: 'Assigned Employees (Skill Level)',
    width: '27%',
    align: 'left',
    tooltip:
      'Multi-select employees capable of this task. L1/L2 require an L3+ supervisor on the same task.',
  },
];
